export default __webpack_public_path__ + "static/media/tech5-black-logo.03b4fba5.svg";